import React from 'react';
import { ScrollView } from 'react-native';

import { Inline } from '@styleseat/ui';
import MicroSearchTile from './MicroSearchTile';
import type { MicroSearchTileProps } from './MicroSearchTile';

type MicroSearchTilesProps = {
  renderLast?: () => React.ReactNode | React.ReactNode[];
  renderFirst?: () => React.ReactNode | React.ReactNode[];
  getTilesAndRenderThem: (
    renderTile: (props: MicroSearchTileProps) => React.ReactNode | React.ReactNode[]
  ) => React.ReactNode | React.ReactNode[];
};

const MicroSearchTiles: React.FCWithChildren<MicroSearchTilesProps> = ({
  getTilesAndRenderThem,
  renderLast,
  renderFirst,
}) => (
  <ScrollView horizontal>
    <Inline
      space={8}
      paddingTop={12}
      paddingBottom={4}
    >
      {renderFirst && renderFirst()}
      {getTilesAndRenderThem(({
        serviceName, serviceImage, onClick,
      }) => (
        <MicroSearchTile
          key={serviceName}
          serviceName={serviceName}
          serviceImage={serviceImage}
          onClick={onClick}
        />
      ))}
      {renderLast && renderLast()}
    </Inline>
  </ScrollView>
);

export default MicroSearchTiles;
